module.exports = __webpack_public_path__ + "img/flash-footer.166f7d96.jpg";